export const FIELDS = {
    INFORMACOES_CLINICAS: 'informacoesClinicas',
    ANTECEDENTES: 'antecedentes',
    ANTECEDENTES_OUTROS: 'antecedentesOutros',
    INDICACAO_EXAME: 'indicacaoExame',
    HISTORIA_CLINICA: 'historiaClinica',
    MEDICAMENTOS_USO: 'medicamentosUso',
    RESULTADO_EXAMES: 'resultadoExames',
};